import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';
import { useState } from 'react';

function Cabins() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "How do I light a fire?",
      answer: "We provide firewood and kindling. Start with small pieces of kindling, add larger pieces gradually, and ensure proper ventilation. Always follow fire safety guidelines and never leave the fire unattended."
    },
    {
      question: "Can we burn candles?",
      answer: "Yes, you can burn candles in the cabin. Please use them safely, place them on stable surfaces away from flammable materials, and never leave them unattended."
    },
    {
      question: "What if I forgot something?",
      answer: "Our pro shop has many essentials available for purchase. You can also contact our staff who will be happy to assist you with any items you may need during your stay."
    },
    {
      question: "How do I book the shower facilities?",
      answer: "Shower facilities are available at our main building. Please check in at the pro shop for access and scheduling. Showers are included with your cabin rental."
    },
    {
      question: "It's hot, how do I cool down?",
      answer: "Take a refreshing dip in our swimming pond! You can also relax in the shade, use the outdoor seating areas, or visit during cooler morning and evening hours."
    },
    {
      question: "What all is included in the cabin?",
      answer: "Each cabin includes a wood-burning stove, sleeping accommodations, outdoor fire pit, BBQ grill, picnic table, Muskoka chairs, and basic furnishings. You'll need to bring your own bedding, towels, and toiletries."
    },
    {
      question: "What if I want something from the cabin or take something that is not mine?",
      answer: "All items in the cabin are for use during your stay only. Please do not remove any items from the cabin. If you need something, please contact our staff at the pro shop who will be happy to assist you."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="mt-16 md:mt-24 py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          {/* Title */}
          <h1 className="text-4xl md:text-6xl text-center uppercase italic tracking-[0.2em] md:tracking-[0.3em] mb-12 md:mb-16 font-light">
            OFF-GRID CABINS
          </h1>

          {/* Hero Image */}
          <div className="mb-12 md:mb-16">
            <img 
              src="/cabin1.webp" 
              alt="Off-Grid Cabins" 
              className="w-full h-[400px] md:h-[600px] object-cover"
            />
          </div>

          {/* Introduction Text */}
          <div className="mb-16 text-center">
            <h2 className="text-xl font-bold mb-6">
              Escape to nature and elevate your Throttle Edge experience with our off-grid cabin rentals!
            </h2>
            <p className="text-gray-800 leading-relaxed mb-4">
              Tucked away in a serene wooded area, each cabin offers a private retreat complete with an outdoor fire pit, BBQ, picnic table, Muskoka chairs, and access to a peaceful pond and garden patch.
            </p>
            <p className="text-gray-800 leading-relaxed mb-4">
              Enjoy the perfect blend of rustic charm and modern comforts as you unwind and rejuvenate in your cozy cabin. Whether you're seeking adventure or a peaceful escape from city life, our cabins provide a tranquil getaway immersed in nature, with all the amenities you need close by for a truly relaxing experience
            </p>
            <p className="font-bold text-lg" style={{ color: '#F5A623' }}>
              For Bookings: <a href="mailto:bookings@throttledge.com" className="text-red-600 hover:underline">bookings@throttledge.com</a>
            </p>
          </div>

          <div className="border-t-2 border-gray-300 mb-16"></div>

          {/* Couples Cabin Section */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl text-center uppercase italic tracking-wider mb-8 md:mb-12 font-light" style={{ color: '#F5A623' }}>
              COUPLES CABIN
            </h2>
            
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div>
                <img 
                  src="/cabin2.webp" 
                  alt="Couples Cabin Exterior" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
              <div>
                <img 
                  src="/cabin3.webp" 
                  alt="Couples Cabin Interior" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>
          </div>

          {/* Couples Cabin Description */}
          <div className="space-y-8 text-gray-800 leading-relaxed">
            <p>
              Designed for the perfect couples' getaway, this charming cabin features a luxurious king-size loft bedroom and a comfy pull-out couch for added space. Savour outdoor dining at the bistro table with a blacktop grill ready for your BBQ feast. As the day winds down, relax by your private fire pit with peaceful views of the forest and a serene mini pond, creating an unforgettable retreat in nature.
            </p>

            <div>
              <h3 className="text-xl font-bold mb-4">Rates & Packages: Winter Rates</h3>
              <ul className="space-y-2 ml-6">
                <li className="list-disc">
                  <span className="font-bold">Weekday Escape (Tuesday - Thursday):</span> PKR 30,843 + HST per night
                </li>
                <li className="list-disc">
                  <span className="font-bold">Weekend Retreat (Friday - Sunday):</span> PKR 45,333 + HST per night
                </li>
              </ul>
            </div>

            <div className="flex justify-center mt-8">
              <button className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-sm font-bold tracking-widest">
                BOOK NOW
              </button>
            </div>
          </div>

          <div className="border-t-2 border-gray-300 my-16"></div>

          {/* Family Cabin Section */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl text-center uppercase italic tracking-wider mb-8 md:mb-12 font-light" style={{ color: '#F5A623' }}>
              FAMILY CABIN
            </h2>
            
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div>
                <img 
                  src="/cabin4.webp" 
                  alt="Family Cabin Exterior" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
              <div>
                <img 
                  src="/cabin5.webp" 
                  alt="Family Cabin View" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>
          </div>

          {/* Family Cabin Description */}
          <div className="space-y-8 text-gray-800 leading-relaxed">
            <p>
              Designed for the perfect family getaway, our cozy cabin at Throttle Edge accommodates up to 5 people. Featuring a spacious loft with 3 beds, a comfy couch, and a welcoming living and dining area, it's ideal for relaxation. Fire up the BBQ for an outdoor feast at the picnic table, then unwind by your private fire pit with peaceful forest views and a serene mini pond. The ultimate retreat for families looking to reconnect with nature!
            </p>

            <div>
              <h3 className="text-xl font-bold mb-4">Rates & Packages: Winter Rates</h3>
              <ul className="space-y-2 ml-6">
                <li className="list-disc">
                  <span className="font-bold">Weekday Escape (Tuesday - Thursday):</span> PKR 37,053 + HST per night
                </li>
                <li className="list-disc">
                  <span className="font-bold">Weekend Retreat (Friday - Sunday):</span> PKR 51,543 + HST per night
                </li>
              </ul>
            </div>

            <div className="flex justify-center mt-8">
              <button className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-sm font-bold tracking-widest">
                BOOK NOW
              </button>
            </div>
          </div>

          <div className="border-t-2 border-gray-300 my-16"></div>

          {/* What Should We Bring Section */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl text-center uppercase italic tracking-wider mb-8 md:mb-12 font-light" style={{ color: '#F5A623' }}>
              WHAT SHOULD WE BRING?
            </h2>
            
            <div className="space-y-3 text-gray-800">
              <p>Bedding / sheets</p>
              <p>Towels</p>
              <p>Toiletries</p>
              <p>Food / ice / cooler</p>
              <p>Battery banks for charging your phone (although you can charge at guest services) / wireless speakers / board games etc (no tv, no electricity)</p>
              <p>Warm clothes / weather appropriate</p>
              <p>Bug spray / sunscreen</p>
              <p>Swimsuits (for the swimming pond)</p>
              <p>Bicycle (bicycle rentals coming soon)</p>
              <p>Dirt Bikes (some are available for rent - please book in advance)</p>
            </div>
          </div>

          <div className="border-t-2 border-gray-300 my-16"></div>

          {/* Custom Event Packages & Catering Section */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl text-center uppercase italic tracking-wider mb-8 md:mb-12 font-light" style={{ color: '#F5A623' }}>
              CUSTOM EVENT PACKAGES & CATERING
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              <div>
                <img 
                  src="/custom1.webp" 
                  alt="Event Setup" 
                  className="w-full h-80 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/custom2.webp" 
                  alt="Catering" 
                  className="w-full h-80 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/custom3.webp" 
                  alt="Event Cake" 
                  className="w-full h-80 object-cover"
                />
              </div>
            </div>

            <div className="mt-8 text-gray-800 leading-relaxed">
              <p>
                Elevate your cabin stay at Throttle Edge with our premium add-ons! Whether you're celebrating a birthday, anniversary, or special event, ask us about our tailored event packages and catering options. Create unforgettable moments in the heart of adventure, with everything you need for a perfect celebration!
              </p>
            </div>
          </div>

          <div className="border-t-2 border-gray-300 my-16"></div>

          {/* About the Property Section */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl text-center uppercase italic tracking-wider mb-8 md:mb-12 font-light" style={{ color: '#F5A623' }}>
              ABOUT THE PROPERTY
            </h2>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              <div>
                <img 
                  src="/about1.webp" 
                  alt="Track" 
                  className="w-full h-64 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/about2.webp" 
                  alt="Trail Riding" 
                  className="w-full h-64 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/about3.webp" 
                  alt="Volleyball" 
                  className="w-full h-64 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/about4.webp" 
                  alt="Fireworks" 
                  className="w-full h-64 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/about5.webp" 
                  alt="Campfire" 
                  className="w-full h-64 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/about6.webp" 
                  alt="Swimming Pond" 
                  className="w-full h-64 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/about7.webp" 
                  alt="Riders" 
                  className="w-full h-64 object-cover"
                />
              </div>
              <div>
                <img 
                  src="/a4.webp" 
                  alt="Sunset View" 
                  className="w-full h-64 object-cover"
                />
              </div>
            </div>

            <div className="mt-12 space-y-6 text-gray-800 leading-relaxed">
              <p>
                Unleash your passion for dirt biking at Throttle Edge, where adventure meets comfort! Stay in our cozy cabins, perfectly located near 5 adrenaline-pumping tracks and 3 scenic trails. Whether you're a seasoned rider or new to the sport, we offer thrilling events, day passes, bike rentals, and expert lessons to elevate your experience. Visit our pro shop to gear up for the ultimate off-road adventure. Click below to learn more about each offering and get ready for an unforgettable ride!
              </p>

              <ul className="space-y-3 ml-6">
                <li className="list-disc">
                  <span className="font-semibold">Daily riding (dirt bikes, side by sides, and ATVs)</span>- Enjoy a day of off-road excitement with our day riding options, giving you full access to our tracks and trails
                </li>
                <li className="list-disc">
                  <a href="#" className="text-red-600 hover:underline font-semibold">Various events</a>- Check out or participate in our thrilling events that take place all year long
                </li>
                <li className="list-disc">
                  <a href="#" className="text-red-600 hover:underline font-semibold">Dirt bike rentals</a>- No bike? No problem! Rent one of ours
                </li>
                <li className="list-disc">
                  <a href="#" className="text-red-600 hover:underline font-semibold">Dirt bike lessons</a>- Take lessons from our expert instructors to sharpen your skills
                </li>
                <li className="list-disc">
                  <a href="#" className="text-red-600 hover:underline font-semibold">Summer camps</a>- Our kids' summer camps offer the ultimate outdoor experience with dirt biking, swimming, and tons of fun activities designed to create lasting memories
                </li>
              </ul>

              <p className="font-semibold">
                Throttle Edge is known not only for its excellent riding opportunities but also for its scenic surroundings, making it a great place for both adventure and relaxation!
              </p>
            </div>
          </div>

          <div className="border-t-2 border-gray-300 my-16"></div>

          {/* Cabin FAQ Section */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl text-center uppercase italic tracking-wider mb-8 md:mb-12 font-light" style={{ color: '#F5A623' }}>
              CABIN FAQ
            </h2>
            
            <p className="text-gray-800 leading-relaxed mb-8 italic">
              To make the most of your experience we wanted to provide you with a list of items within the cabin, on the property and guidance on the best experience. This is truly a classic cabin experience that includes a real wood burning stove to warm your cabin and bring the ambiance. Outdoor plumbing and cooking - but don't worry, we have showers on-site, and classic basin/bowl hand washing stations in your tiny home-away-from-home too!
            </p>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="border-b border-gray-300 pb-4">
                  <button 
                    onClick={() => toggleFaq(index)}
                    className="w-full text-left flex justify-between items-center text-gray-800 hover:text-gray-600"
                  >
                    <span>{faq.question}</span>
                    <svg 
                      className={`w-5 h-5 transition-transform ${openFaq === index ? 'rotate-180' : ''}`}
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openFaq === index && (
                    <div className="mt-4 text-gray-700 leading-relaxed">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Cabins;
